export default "__VITE_PUBLIC_ASSET__650a5c82__"